module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("A")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Arius before Arianism")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-1"
    }
  }, [_vm._v("1 ORIGINS")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Epiphanius tells us"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-1",
      "id": "ch1note_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" that Arius was born in Libya: and a number of other small pieces of evidence tend to bear this out. Arius’ two most consistent episcopal supporters in later years were Secundus and Theonas,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-2",
      "id": "ch1note_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" bishops respectively of Ptolemais (or ‘the Pentapolis’, in some texts)"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-3",
      "id": "ch1note_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" and Marmarica: Ptolemais was the chief city of western or ‘upper’ Libya, the older Cyrenaica, whose five major coastal settlements gave the district its familiar name of the Pentapolis; Marmarica or ‘lower Libya’ (sometimes "), _c('em', [_vm._v("Libya sicca)")]), _vm._v(" was the desert area between Cyrenaica and the "), _c('em', [_vm._v("fines Alexandriae,")]), _vm._v(" the border of the urban area of Alexandria at the western end of the Mareotis."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-4",
      "id": "ch1note_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Diocletian’s reorganization of the empire established the distinction between the ‘two Libyas’ as a matter of nomenclature but there is no secure evidence as to whether this was also an -administrative division. Whatever the truth of this, it sounds as though Secundus and Theonas may have been effectively metropolitans of the Libyan districts;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-5",
      "id": "ch1note_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" and when Philostorgius, the Arian historian, lists other bishops sympathetic to Arius,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-6",
      "id": "ch1note_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" the first four are from some of the other cities in the Pentapolis. In fact, we know of no Libyan bishops opposing Arius; given a certain amount of Libyan resistance to the claims of the Alexandrian see over its western neighbours,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-7",
      "id": "ch1note_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" it would not be surprising if a Libyan cleric in trouble with the bishop of Alexandria commanded more or less unanimous support from his homeland.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The same picture is suggested in a letter from the Emperor Constantine to Arius, written around 333."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-8",
      "id": "ch1note_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Arius had been given permission to return from exile to his ‘native territory’ (unspecified) in 327 or 328,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-9",
      "id": "ch1note_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" and Constantine writes as though Arius is currently in Libya. Evidently Arius is enjoying widespread popular support, "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("since Constantine shows signs of panic at the idea of a schism. A little earlier (331 or 332), we find Athanasius visiting Libya,"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-10",
      "id": "ch1note_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" and the emperor’s letter clearly suggests that it was becoming a very troubled area from the point of view of the Alexandrian see. Once again, the whole pattern makes excellent sense in terms of partisanship for a local celebrity against intrusive foreign prelates.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If Epiphanius is to be relied on as regards Arius’ place of birth, is he also to be trusted when he describes Arius as an ‘old man’, "), _c('em', [_vm._v("gerōn,")]), _vm._v(" at the time of the outbreak of the controversy?"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-11",
      "id": "ch1note_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Here we have no collateral evidence, though Constantine’s letter of 333 contains a passage"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-12",
      "id": "ch1note_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" describing, in most insulting fasion, Arius’ wasted and lifeless appearance – a passage which certainly fits a man well-advanced in years. The widespread consensus that puts Arius’ birth in the 250s"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-13",
      "id": "ch1note_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" has no definite foundation in the texts of the fourth and fifth centuries, but it seems safe to assume that he was not a young man when the crisis broke. If he was ordained presbyter by Bishop Achillas, as several sources claim,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-14",
      "id": "ch1note_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" and if the Nicene regulations about the minimum canonical age for such ordinations reflect earlier practice, he was at least thirty in 313. All in all, a date for Arius’ birth some time before 280 is most likely; assuming that Epiphanius has an authentic tradition behind what he writes, we can probably push this date rather further back, but without any hope of certainty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The only clue we have as to Arius’ education is the single word "), _c('em', [_vm._v("sulloukianista,")]), _vm._v(" which occurs in his letter to Eusebius, bishop of Nicomedia, appealing for help in the first years of the controversy. Historians have generally taken ‘fellow-Lucianist’ pretty literally, and assumed a period of study with the martyr Lucian of Antioch. Ever since Newman,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-15",
      "id": "ch1note_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" this has produced some very questionable reconstructions of Arius’ intellectual background;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-16",
      "id": "ch1note_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" but in fact – yet again – we can be certain of very little. Lucian’s own theology has to be reconstructed from hints and allusions (and there is also a credal statement used by the synod of Antioch in 341 which was alleged to have originated with Lucian);"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-17",
      "id": "ch1note_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" he cannot be taken as representative of an Antiochene ‘school’ of theology or exegesis (he taught in Nicomedia for some of his career at least);"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-18",
      "id": "ch1note_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" and it is in any case not clear that we should assume from the one word in Arius’ letter that he had actually been Lucian’s student. Wallace-Hadrill notes"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-19",
      "id": "ch1note_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" that Arius is not named by Philostorgius in his lists"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-20",
      "id": "ch1note_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" of Lucian’s pupils, and supposes that the Lucianists formed a "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("coherent political and theological grouping quite independently of Arius. Certainly, if Philostorgius is to be believed, there were real theological divergences between this group and Arius,"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-21",
      "id": "ch1note_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" and the later ‘neo-Arians’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-22",
      "id": "ch1note_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" of the mid-century traced their theological ancestry back to the Lucianists rather than Arius. This is not entirely conclusive: Philostorgius is not by any means a reliable source, and we need not, in any case, assume that he ever means to give a full list of Lucian’s pupils. But the anti-Nicene theological tradition evidently preserved the memory of a certain distance between Arius and some of his allies; it cannot be taken for granted that Arius was a "), _c('em', [_vm._v("disciple")]), _vm._v(" of Lucian in the sense that others such as Eusebius of Nicomedia claimed to be, even if he had attended lectures by the martyr. ‘Fellow-Lucianist’ may be no more than a "), _c('em', [_vm._v("captatio benevolentiae")]), _vm._v(" – laying claim to common ground with potential supporters; or it may rest on the fact that Arius "), _c('em', [_vm._v("had")]), _vm._v(" studied, in Antioch or Nicomedia, with Lucian. It is very doubtful whether it tells us much about what lies behind Arius’ utterances in terms of theological formation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Likewise, although he is described as a skilled dialectician,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-23",
      "id": "ch1note_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" we cannot with confidence reconstruct a philosophical education. If he was (as has been argued)"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-24",
      "id": "ch1note_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" indebted to certain currents in revived Aristotelianism and Iamblichus’ version of Neoplatonism, he could have encountered such teaching in Syria around 300, when Iamblichus himself was teaching at Antioch and Apamea."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-25",
      "id": "ch1note_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Iamblichus’ teacher Anatolius was probably the Alexandrian Christian Aristotelian described with some veneration by Eusebius;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-26",
      "id": "ch1note_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" he ended his life (we do not know exactly when, but probably in the 270s) as bishop of Laodicaea, and seems to have been caught up at some point in the struggle against Paul of Samosata. A tempting candidate for the role of Arius’ mentor he is still regrettably a shadowy figure: no evidence connects him directly with the heresiarch, and we should have to push the date of Arius’ birth a good way back into the 250s to make any personal contact possible. Links with Anatolius and his celebrated pagan pupil, a period of studying philosophy in Syria – these are intriguing possibilities, but no more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whatever the nature and extent of his putative earlier travels, the Arius who at last emerges into clear historical light at the end of the second decade of the fourth century is firmly anchored in Alexandria, presbyter of an important church and a popular "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("preacher with a reputation for asceticism. Epiphanius’ pen-portrait"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-27",
      "id": "ch1note_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" is worth reproducing:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("He was very tall in stature,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-28",
      "id": "ch1note_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" with downcast countenance"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-29",
      "id": "ch1note_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" – counterfeited like a guileful serpent, and well able to deceive any unsuspecting heart through its cleverly designed appearance. For he was always garbed in a short cloak "), _c('em', [_vm._v("(hēmiphorion)")]), _vm._v(" and sleeveless tunic "), _c('em', [_vm._v("(kolobion);")]), _vm._v(" he spoke gently, and people found him persuasive and flattering.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The sleeveless tunic is reminiscent of the "), _c('em', [_vm._v("exōmis")]), _vm._v(" worn both by philosophers and by ascetics: Philo"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-30",
      "id": "ch1note_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" mentions that the contemplative Therapeutae of his day were dressed thus. Arius’ costume would have identified him easily as a teacher of the way of salvation – a guru, we might almost say. It is not surprising that Epiphanius also notes"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-31",
      "id": "ch1note_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" that he had the care of seventy women living a life of ascetic seclusion, presumably attached to his church. What we do not know is precisely how long Arius had occupied this influential post; as already noted, he is said to have been ordained by Achillas, and, according to Theodoret,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-32",
      "id": "ch1note_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Achillas’ successor Alexander gave him authority to ‘expound the Scriptures in church’. So we can perhaps trace Arius’ public career back as far as 313, and assume that, for most of this decade, he ministered at the church which Epiphanius calls ‘Baucalis’"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-33",
      "id": "ch1note_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" – a respected cleric of some seniority, with a high reputation as a spiritual director. Before 313, nothing is clear; however, one story surfaces in the middle of the fifth century which has been widely believed, and, before going any further, it is necessary to look briefly at this. It is the allegation made by Sozomen"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-34",
      "id": "ch1note_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" that Arius was involved in the most serious internal disruption of Egyptian church life prior to the controversy over his own teaching: the schism initiated in 306 by Melitius, bishop of Lycopolis.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-2"
    }
  }, [_vm._v("2 THE TROUBLES OF THE ALEXANDRIAN CHURCH I: THE MELITIAN SCHISM")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In February 303, Diocletian initiated what was to prove the most serious and sustained persecution the Christian Church had so far endured. In the eastern part of the empire and in Africa, martyrdom "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("became common; though in the West, Diocletian’s colleague Maximian and Maximian’s junior coadjutor Constantius, father of Constantine, did virtually nothing to further the persecution in their territories."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-35",
      "id": "ch1note_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" When, in 305, Diocletian abdicated in favour of his fanatically anti-Christian second-in-command, the Caesar Galerius, the situation in the East deteriorated further from the Church’s point of view. Galerius’ protégé Maximin was given the rank of Caesar and put in charge of Egypt and Syria (the civil diocese of ‘the East’, Oriens); under his supervision, the persecution continued with hardly any interruption"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-36",
      "id": "ch1note_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" until 313, when Licinius seized power in the eastern empire. These eight years were a costly time for the Church in Egypt, in more senses than one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Several bishops suffered in the persecution (though some such as Apollonius of Lycopolis in the Thebaid publicly apostatized);"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-37",
      "id": "ch1note_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" and the prolonged imprisonment of a bishop would create obvious problems for his diocese. It seems that the bishops lost little time in devising a system whereby certain of their responsibilites were delegated to ‘visitors’ in case of an emergency:"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-38",
      "id": "ch1note_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" these visitors would have seen to it that poor relief continued to be administered, and it is possible, though very far from certain, that (if they were presbyters) they also had some responsibility for the maintenance of preaching or catechesis."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-39",
      "id": "ch1note_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Probably at some point late in 305 or early in 306, four Egyptian bishops, Hesychius, Pachomius, Theodorus and Phileas, wrote from prison to their confrere, the newly-appointed bishop of Lycopolis (Apollonius’ successor),"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-40",
      "id": "ch1note_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" to complain that he had entered their dioceses and performed ordinations, contrary to established law and custom. If he should argue in his defence that there is a grave pastoral need to be met, this is far from the truth: there is no shortage of authorized visitors "), _c('em', [_vm._v("(circumeuntes et potentes visitare) -")]), _vm._v(" and, in any case, it is for the people of the diocese themselves to make representations to their bishops if they think they are being neglected. The sole circumstance in which such behaviour might be permitted would be if the bishop of Lycopolis had received a direct commission from the bishop of Alexandria;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-41",
      "id": "ch1note_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" and this would only be possible in the event of a diocesan’s death and a subsequent interregnum. Melitius of Lycopolis has not consulted with the imprisoned bishops, nor, it appears, has he referred the alleged problems of the orphaned dioceses to Peter of Alexandria: he has ordained unsuitable and factious persons (for "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("how could a peripatetic bishop judge the suitability of candidates in an unfamiliar diocese?), and caused grave divisions in the churches.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Peter, we gather, was absent from Alexandria, in flight or in hiding; later legend"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-42",
      "id": "ch1note_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" has him travelling beyond the imperial frontier in Mesopotamia, and spending long periods in Syria, Palestine and ‘the islands’ (Cyprus?), but the implications of the bishops’ letter are that he can be reached without too much difficulty. At this particular point, anyway, he is most unlikely to have been outside Egypt. This is reinforced by the fragment of narrative that follows the bishops’ letter in the codex (from the Chapter Library at Verona) which preserves the text:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("After he had received and read this letter, he [Melitius] did not reply nor did he visit them in prison, nor did he go to blessed Peter: but when all these bishops, presbyters and deacons had been martyred in the prison in Alexandria,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-43",
      "id": "ch1note_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" he immediately entered Alexandria. There was a man called Isidore in the city, a regular troublemaker, eager to be a teacher "), _c('em', [_vm._v("[or:")]), _vm._v(" eager to run his own faction];"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-44",
      "id": "ch1note_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" and also a certain Arius, who had an outward appearance of piety, and he too was eager to be a teacher. When they had discovered what Melitius wanted and what it was that he required, they lost no time in joining up with him (being envious of the authority of blessed Peter); and – with the result that Melitius’ aims became publicly known – they pointed out to him where the presbyters to whom blessed Peter had delegated the power to visit the districts of Alexandria were in hiding. Melitius notified them [sc. the presbyters] of a charge against them,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-45",
      "id": "ch1note_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" excommunicated them,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-46",
      "id": "ch1note_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" and himself ordained two persons, one to work in prison, the other to work in the mines."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-47",
      "id": "ch1note_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("It seems as though the complaint is that the episcopal deputies are not doing their job: Isidore and Arius are able to tell Melitius that the ‘visitors’ themselves have gone into hiding, giving Melitius an "), _c('em', [_vm._v("occasio")]), _vm._v(" for suspending them. The ordinations cannot have followed immediately: Egyptian Christians were first transported to the Palestinian mines in 307 or 308, so at least one of Melitius’ new presbyters is unlikely to have received his orders in 306. This presupposes that Melitius stayed in Alexandria for several years -as we should deduce from the letter of Peter to his flock which immediately follows this narrative fragment in our collection. Peter "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("writes as if Melitius is still in the city, having ordained a number of ‘prison chaplains’ and broken communion with Peter’s own delegates."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-48",
      "id": "ch1note_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" If this reading is right, Melitius saw a pastoral need not only in the dioceses of the Nile Delta in general, but among the prisoners in particular, and was concerned that there should be those among the presbyters whose main job it was to minister to them – which would fit with the remark in the passage quoted about his activities following on a general slaughter of the clergy who happened to be already in custody."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-49",
      "id": "ch1note_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" It may be also that he regarded some of the clergy left in the prisons as, for some reason, disqualified from administering the sacraments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This raises the question of whether there is any truth in Epiphanius’ version of the schism (probably derived from Melitian sources),"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-50",
      "id": "ch1note_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" in which the real issue between Peter and Melitius (who is described as a kind of archbishop, second in rank to Peter) is the treatment of those who lapsed under persecution. Melitius is represented as objecting to Peter’s canons on this matter, during a period when both bishops were in prison together. Since the canons we possess"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-51",
      "id": "ch1note_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" date from Easter 306, when Melitius was almost certainly at liberty and Peter was probably in hiding or abroad, Epiphanius’ circumstantial tale cannot be true as it stands. Later Melitians, who certainly described themselves as ‘the church of the martyrs’,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-52",
      "id": "ch1note_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" may have thought it in their interest to depict the schism as a dispute of the familiar kind about penitential rigorism in the Church. Peter’s canons are fairly lenient, though hardly scandalously so, and their publication may have offended Melitius, and removed any remaining scruples he may have had about usurping the bishop’s office in Alexandria: it would not be surprising if he were a rigorist, especially in the light of his predecessor’s apostasy at Lycopolis."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-53",
      "id": "ch1note_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" However, we can be confident that this was not the main cause of the schism, since it is perfectly clear that Melitius was active before the spring of 306. A dispute over the canons sounds like an "), _c('em', [_vm._v("ex post facto")]), _vm._v(" justification for his behaviour. Nor is it even clear that Melitius himself was "), _c('em', [_vm._v("ever")]), _vm._v(" in prison in Egypt."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-54",
      "id": "ch1note_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" If we largely discount Epiphanius, and translate the notoriously difficult "), _c('em', [_vm._v("in carcere et in metallo")]), _vm._v(" of the Verona text as I have suggested, and not as implying that Melitius is himself in custody, we are left with a straightforward picture of Melitius as an "), _c('em', [_vm._v("episcopus vagans")]), _vm._v(" taking full advantage of the disorder of the Church in the Delta between 306 and 311 to establish a firmly-rooted rival jurisdiction, "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("unhampered by the attentions of the persecutors. Peter’s concern, as shown in his letter to Alexandria, is far more intelligible if Melitius is supposed to be at large in the Delta for a substantial period than if he is conducting ordinations from his own cell (let alone in the distant Phaeno mines). And Athanasius’ rather absurd accusation"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-55",
      "id": "ch1note_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")]), _vm._v(" that Melitius had been deposed for apostasy among other unspecified crimes would be a little more surprising if Melitius were generally known in Egypt to have suffered as a confessor – though Athanasius is never a fanatically accurate controversialist. Epiphanius "), _c('em', [_vm._v("may")]), _vm._v(" – through his connections with Melitian communities in Palestine – have access to a genuine memory that Melitius spent some time in the Phaeno under Maximin. But the Palestinian communities need not owe their genesis directly to Melitius himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The point that chiefly concerns us, however, is whether the Arius of the sketchy narrative quoted above is the heresiarch himself. Sozomen’s outline of Arian origins"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-56",
      "id": "ch1note_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" unambiguously presupposes this identification, and adds further circumstantial detail. Arius is a supporter of Melitius’ ‘innovations’ who subsequently is reconciled with Peter and made deacon by him; however, when Peter excommunicates Melitius and denies the validity of Melitian baptism, Arius objects, and – we are left to presume – is deposed or excommunicated. He succeeds in making his peace with Achillas after Peter’s death, is restored to his orders and later ordained as a presbyter. This story is again reproduced with still further elaboration, in an eighth-century Latin version of the "), _c('em', [_vm._v("passio")]), _vm._v(" of Peter:"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-57",
      "id": "ch1note_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" the earlier (perhaps sixth century) Greek original"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-58",
      "id": "ch1note_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" had already related how the imprisoned Peter refused to restore Arius to communion, foreseeing in a prophetic dream that Arius would divide the whole church, but had rather bizarrely represented Arius as already under censure for "), _c('em', [_vm._v("heresy."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-59",
      "id": "ch1note_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])]), _vm._v(" The intelligent Latin translator, aware that this could not be right, filled out his version with detail from elsewhere,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-60",
      "id": "ch1note_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" assimilating the course of events roughly to Sozomen’s account. It has been argued"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-61",
      "id": "ch1note_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" that, in this reworking, he made use of an Alexandrian dossier of synodical and related material in which are contained the documents concerning Melitian origins already quoted – a dossier perhaps drawn up originally as a ‘Jubilee Book’ to celebrate Athanasius’ fortieth anniversary as bishop of Alexandria in 368. This book, it appears, or substantial portions of it, travelled to Carthage in 419, in response to a request for information about the Alexandrian texts of the canons of Nicaea and "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Serdica, and finally found its way into the rather disparate collection of canonical and narrative pieces preserved in the celebrated Verona Codex LX. Specifically, the attèmpt has been made to show that this book "), _c('em', [_vm._v("in its full form")]), _vm._v(" was the source for the additional detail in the Latin "), _c('em', [_vm._v("passio")]), _vm._v(" about Arius’ Melitian phase, since the translator does not mention Sozomen as a source, and none of the other recognizable supplementary sources named carries an adequately complete version of the story: the one otherwise unidentifiable source, a Latin "), _c('em', [_vm._v("libellus")]), _vm._v(" containing much material on Athanasius, would then have been the Jubilee Book itself, in a rather fuller Latin version than that surviving in the Verona codex. And if all this is granted, Sozomen’s story is independently confirmed, and the identification of the Melitian Arius with the Arius of the later controversy becomes overwhelmingly probable.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("This ingenious case must, unfortunately, be regarded as far from proven. We simply do not know how much more narrative the ‘Jubilee Book’ contained, but we do know that the letter of Peter excommunicating Melitius followed immediately on the narrative section mentioning Arius; there is no room for a reconciliation with Peter and a later breach when the bishop rules against Melitius. There "), _c('em', [_vm._v("may")]), _vm._v(" have been further documents confirming the excommunication and rejecting the validity of Melitian baptism, but this is pure speculation. In fact there are no elements in the Latin "), _c('em', [_vm._v("passio")]), _vm._v(" that "), _c('em', [_vm._v("could")]), _vm._v(" not have come from Sozomen: the redactor obviously knew of Sozomen’s low reputation as an historian,"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-62",
      "id": "ch1note_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" and may have been reluctant to mention him for this reason. So, although it is highly probable that the "), _c('em', [_vm._v("libellus")]), _vm._v(" used by the Latin translator was indeed the Jubilee Book, we cannot confidently assert that it provided him with a full and circumstantial account of Arius’ schismatic adventures, independently corroborating Sozomen. We cannot even know for sure that the translator had any more of the Jubilee Book before him than we have, as no other identifiable fragments survive,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-63",
      "id": "ch1note_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" though one or two details"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-64",
      "id": "ch1note_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" do suggest that he may have been familiar with documents not preserved in the Verona codex.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The identification thus rests solely on Sozomen’s authority; and it must confront the monumental objection that no writer before Sozomen so much as hints at it. Alexander of Alexandria"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-65",
      "id": "ch1note_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" angrily describes Arius’ arrogantly divisive behaviour without adding that it is not the first time this has been in evidence; Athanasius"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-66",
      "id": "ch1note_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("describes the obstinacy of the Melitians and their tactical alliance with the anti-Nicene party without any suggestion that this was what might have been expected in the light of the earlier history of Melitius and Arius; Epiphanius too"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-67",
      "id": "ch1note_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(" has an account of the Arian-Melitian rapprochement after Nicaea, but the only previous link that he mentions is a tradition"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-68",
      "id": "ch1note_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" that Melitius was the first to denounce Arius’ heresy to Alexander (some"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-69",
      "id": "ch1note_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" have seen in this Melitius’ delayed revenge for Arius’ desertion). It is hard to believe that any of these could have refrained from mentioning a connection potentially discreditable to both groups of adversaries; and Alexander and Athanasius at least were in the best possible position to know Arius’ record.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is just conceivable that the Alexandrian bishops fail to mention this because of embarrassment at the stance on Melitian baptism allegedly taken by Peter: Arius’ objections would have been vindicated by the Nicene canons, which prescribe rebaptism only for unequivocal heretics (followers of the ‘unitarian’ theology of Paul of Samosata)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-70",
      "id": "ch1note_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" And, as far as we can tell, the position of the great Dionysius of Alexandria in the mid-third century was inimical to a uniformly rigorist policy towards baptism outside the Catholic fold."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-71",
      "id": "ch1note_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" Batiffol long ago pointed out"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-72",
      "id": "ch1note_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" that Sozomen’s story was not particularly creditable to Peter in the light of subsequent practice and policy; and it would certainly be a striking fact if he so dramatically rejected the views of the greatest and most authoritative of his predecessors. However, Athanasius and Alexander would not have needed to go into details: the mere fact that Arius’ past had been ecclesiastically murky would have sufficed. Interestingly, the Latin redactor of the "), _c('em', [_vm._v("passio")]), _vm._v(" omits all mention of a controversy over baptism, and has Arius simply objecting to the excommunication of Melitius’ party: why could not a fourth-century writer have been similarly selective?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In fact, no source other than Sozomen (once again) suggests that the validity of Melitian baptism was ever at issue; had it been, we should expect the Nicene canons to pronounce on it, as they do on Novatianist and Paulinian baptisms and Melitian ordinations."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-73",
      "id": "ch1note_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" It begins to look as though this detail of the story at least derives from quarters eager to discredit Peter and whitewash the memory of Arius. Sozomen is heavily dependent in this section of his history on the Arian chronicler Sabinus of Heraclea,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-74",
      "id": "ch1note_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" about whose reliability Socrates has some hard things to say;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-75",
      "id": "ch1note_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" it seems highly probable "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("that Sabinus is the ultimate source of the identification of the two Arii. Sabinus was writing in the 370s: he is likely to have known the Jubilee Book and it is indeed quite possible"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-76",
      "id": "ch1note_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")]), _vm._v(" that he composed his "), _c('em', [_vm._v("Synodikon")]), _vm._v(" as a counterblast to the Athanasian anthology which was beginning to circulate in the eastern Mediterranean. If we assume that he knew Arius to have been a deacon under Peter, the mention of a schismatic "), _c('em', [_vm._v("lay")]), _vm._v(" Arius"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-77",
      "id": "ch1note_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" in Peter’s reign would suggest a rupture of some kind: Arius must have been reconciled with Peter before his ordination. The further refinement of a subsequent break and reconciliation, culminating in presbyteral ordination by Achillas is a bit more puzzling. It may be pure invention; but, at the risk of over-ingenuity, we might perhaps imagine a further letter or letters from Peter in the Jubilee Book"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-78",
      "id": "ch1note_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" immediately preceding some notice of his martyrdom, which, like Alexander’s encyclicals against Arius, carried a list of those excommunicated along with their ringleader – a list including the name of "), _c('em', [_vm._v("Arius quidam.")]), _vm._v(" Add to this a (Melitian?) tradition that Peter had at some point rejected Melitian baptism, and you have all the materials for a story that – from an Arian or Melitian point of view – is flattering to Arius and unflattering to his bishop: Arius appears as the defender of genuine Catholic and Alexandrian tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The coincidence of two troublesome churchmen named Arius in Alexandria during the same period is-hardly greater than the fact that Arius (the heretic) had an associate of the same name."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-79",
      "id": "ch1note_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" But for Sabinus, the identification must have seemed irresistibly obvious: and at a time when Arians and Melitians were allies, the picture of an Arius supporting Melitius against Peter would serve a useful political purpose. The Catholic historian Socrates ignores this story, recognizing that, as Sabinus tells it, it is a rather double-edged weapon; the less intelligent Sozomen seizes upon it to discredit Arius. The rather confused tradition of Peter’s excommunication of Arius then finds its way into the Greek "), _c('em', [_vm._v("passio;")]), _vm._v(" and, finally, the author of the Latin version makes an impressive attempt to reconstruct a full narrative. He uses Theophanes and Cassiodorus to correct some chronological and other errors in the Greek, and finds in them"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-80",
      "id": "ch1note_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" the outline of the tradition of Arius’ Melitian episode; he turns to the Jubilee Book (if this is indeed his "), _c('em', [_vm._v("libellus)")]), _vm._v(" for further information about Melitian origins (he knows the letter of the imprisoned bishops to Melitius, and, apparently, one or more letters from Peter to them);"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-81",
      "id": "ch1note_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" and at last, perhaps aware of the same "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("puzzles that Sabinus faced (Arius is ordained by Peter, yet appears as a layman, both in 306 or thereabouts, and in a list of excommunicates in 311), he checks Cassiodorus against his sources and comes up with Sozomen’s story, which he proceeds to reproduce in splendidly vivid and dramatic form.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("So the Melitian Arius, beloved of several modern scholars,"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-82",
      "id": "ch1note_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")]), _vm._v(" appears to melt away under close investigation. The only thing emerging from this jumble of unreliable tradition that looks at all like a fact is the assertion that Arius was ordained deacon by Peter: if this was recognized as well-established recollection in the fourth century, it would explain a good deal of what I have proposed as the later development of the story. Probably we can also take it that Arius was indeed ordained presbyter by Achillas,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-83",
      "id": "ch1note_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" as all the historians agree in describing him as already a presbyter on the succession of Alexander. Two texts record one final piece of tradition about Arius prior to the outbreak of the controversy: Theodoret"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-84",
      "id": "ch1note_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" and Philostorgius"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-85",
      "id": "ch1note_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" state that he was a candidate in the episcopal election of 313. According to Theodoret, Arius’ defeat by Alexander was a contributory factor in his later delinquencies; according to Philostorgius, Alexander owed his victory to the fact that Arius was prepared to transfer to his rival the votes that had been cast for himself. In literary terms, these narratives are independent; both are nakedly propagandist versions of a tradition, which, however, neither of them is likely to have invented "), _c('em', [_vm._v("ex nihilo.")]), _vm._v(" Disappointed ambition as a stimulus for heresy is a theme found elsewhere (Tertullian"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-86",
      "id": "ch1note_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" tells a similar tale about the Gnostic Valentinus); but, as with the Melitius story, we should expect Alexander or Athanasius to make some capital out of such a fact. And if Philostorgius’ version is true, might not Arius himself or his allies have had a word to say about Alexander’s ingratitude, in their protests about the bishop’s treatment of the heresiarch? It seems most likely that a ‘disappointed ambition’ story grew up in Catholic circles as part of a conventional explanation for Arius’ behaviour, and that Philostorgius, not confident enough to ignore this, attempted to rewrite the record in Arius’ favour. However, it is not clear that we can be absolutely certain that all this is pure legend: our sources agree in representing Arius as an extremely popular figure a few years later, and it can hardly be thought impossible that he should be thought suitable for episcopal election. We are left with yet another of those "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("tantalizing possibilities hovering on the margin of what we can securely know of Arius.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-3"
    }
  }, [_vm._v("3 THE TROUBLES OF THE ALEXANDRIAN CHURCH II: BISHOPS AND PRESBYTERS")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("The church of which Alexander became bishop in 313 does not seem to have been a particularly harmonious body. In addition to the Melitian problem, there were evidently difficulties with an ultra-ascetic group associated with a certain Hieracas (or Hierax) of Leontopolis:"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-87",
      "id": "ch1note_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")]), _vm._v(" Hieracas questioned the resurrection of the body, held that Christians should practise celibacy, and also denied that baptized children would have an opportunity of entering heaven if they died in infancy, as they had done nothing to deserve salvation. His strange views on the Holy Spirit are recorded by Epiphanius,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-88",
      "id": "ch1note_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" and Arius lists him"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-89",
      "id": "ch1note_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" among the trinitarian heretics whose views he repudiates. One further, rather intriguing, fact mentioned by Epiphanius"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-90",
      "id": "ch1note_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" is that Hieracas was fluent in Coptic as well as Greek, and wrote extensively for a non-Greek speaking public: a point which should lead us to tread very carefully in attempting to correlate schism or heresy with ethnic tensions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-91",
      "id": "ch1note_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" Hieracas has some affinities with Origen, as Epiphanius notes, so that a deep gulf at this date between sophisticated Greek-speaking speculative thinkers and simple Coptic faithful is unlikely."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-92",
      "id": "ch1note_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" How serious a threat the ‘Hieracite’ movement was to the Egyptian church we cannot tell: the dearth of fourth-century reference suggests that it was a small and localized group, which probably never spread beyond the Delta. Its interest is in the evidence it provides, not only for theological bilinguality, but also for the survival, in close proximity to normative Catholic circles, of gnostic or ‘Encratite’ views, and for the authority accorded to extra-canonical literature: Hieracas made significant use of the Jewish-Christian apocalyptic fantasy, the "), _c('em', [_vm._v("Ascension of Isaiah."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-93",
      "id": "ch1note_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])])]), _vm._v(" In other words, it was quite possible in the early fourth century for a Christian group not far from Alexandria to take for granted a number of profoundly ‘un-Catholic’ things: the authority of a gifted teacher, an exemplary spiritual hero,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-94",
      "id": "ch1note_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" could operate in such a group quite without reference to the authority of bishop or canon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The case of Hieracas focuses in a particularly sharp way some of "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("the difficulties Alexander faced in Alexandria itself. The bishop of Alexandria occupied at this date what may seem a highly paradoxical position in the Egyptian church: on the one hand – as our evidence has already hinted – he more closely resembled an archbishop or even a patriarch than any other prelate in Christendom. The letter of the four imprisoned bishops to Melitius speaks of Peter as something more than a mere senior confrere: the plain implication of the text"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-95",
      "id": "ch1note_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")]), _vm._v(" is that he has the right to appoint ‘commissaries’ in vacant sees; and there is a fair amount of evidence"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-96",
      "id": "ch1note_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" that he normally consecrated other Egyptian bishops, and perhaps even nominated them. At least from the time of Dionysius,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-97",
      "id": "ch1note_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" he was addressed as "), _c('em', [_vm._v("papa,")]), _vm._v(" and other bishops in Egypt refer to him as their ‘father’."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-98",
      "id": "ch1note_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" On the other hand, within Alexandria itself the bishop was surrounded by powerful and independent presbyters, supervising their own congregations: there is already something like a ‘parochial’ system, with the bishop as president of a college of near-equals. Dionysius still writes"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-99",
      "id": "ch1note_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" to his ‘fellow presbyters’ in the mid-third century. A rather confused tradition long survived that, until the accession of Athanasius in 328, the bishop was consecrated by the Alexandrian presbyteral college and not by any other bishop; and although the evidence is unclear, such a practice would by no means b"), _c('em', [_vm._v("e")]), _vm._v(" surprising."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-100",
      "id": "ch1note_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" Despite his unique powers in the rest of Egypt, the Alexandrian pope remained, in his own city, a "), _c('em', [_vm._v("primus inter pares.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We have no evidence as to the origins of the ‘parochial’ system in Alexandria, although references in Eusebius"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-101",
      "id": "ch1note_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" to the ‘churches’ and "), _c('em', [_vm._v("paroikiai")]), _vm._v(" (which more commonly means ‘dioceses’) of Alexandria go back to the early third century. The city was, in any case, split into five districts,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-102",
      "id": "ch1note_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" with very clear physical dividing lines;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-103",
      "id": "ch1note_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" and it is possible that this encouraged a plurality in Christian leadership from an early date. However, the names we possess of the various Alexandrian churches do not easily fit into the geography of the separate sectors, and the distribution of presbyters and churches was probably more haphazard. Epiphanius tells us"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-104",
      "id": "ch1note_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" that Alexandria had an unusually large number of churches in his day, in addition to the episcopal basilica, the Kaisareion,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-105",
      "id": "ch1note_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" and gives the names of nine – the churches of Dionysius, Theonas, Pierius, Serapion, Persaea, Dizya, the Mendidion, Annianus and Baucalis – adding that this is not a complete list. The later "), _c('em', [_vm._v("passio")]), _vm._v(" of Peter refers"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-106",
      "id": "ch1note_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" to a shrine on the site of St Mark’s martyrdom in the "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("‘Boukolia’ district, eastward of the new harbour area which extended beyond the mole leading out to the Pharos, probably near the north-eastern necropolis; this may be identical with Epiphanius’ ‘Baucalis’."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-107",
      "id": "ch1note_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")]), _vm._v(" We also hear in the "), _c('em', [_vm._v("passio"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-108",
      "id": "ch1note_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])])]), _vm._v(" of a church dedicated to the Mother of God built by Peter, somewhere in the region of the western necropolis. Athanasius refers"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-109",
      "id": "ch1note_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" to a church called "), _c('em', [_vm._v("Kyriou")]), _vm._v(" – or, more likely, "), _c('em', [_vm._v("Kyrinou")]), _vm._v(" – but gives no clue as to its whereabouts, or its date or origin. The great church of St Michael, on the edge of the Jewish quarter, had been a temple of Saturn; we are told"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-110",
      "id": "ch1note_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" that it was turned over to Christian use during the episcopate of Alexander (probably only after 324). Most other churches of which anything is known are substantially later in date.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Epiphanius’ ‘Mendidion’ is an anachronism in a list of "), _c('em', [_vm._v("early")]), _vm._v(" fourth-century churches: Athanasius consecrated this new church in the old forum area in August 370,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-111",
      "id": "ch1note_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" to relieve the long-felt overcrowding in the older church of Dionysius nearby."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-112",
      "id": "ch1note_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" The church of Theonas may originally have been built by the bishop whom it commemorates, but was certainly rebuilt (again to relieve overcrowding) by Alexander:"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-113",
      "id": "ch1note_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" it seems to have been in regular use for larger gatherings before the building of the Mendidion and the conversion of the former temple of Augustus, the Kaisareion, into a basilica."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-114",
      "id": "ch1note_114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" It was known as the church of the Mother of God by the sixth century,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-115",
      "id": "ch1note_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" and may be identical with the shrine mentioned in the "), _c('em', [_vm._v("passio")]), _vm._v(" of Peter: the statement that he built it need not be taken too strictly (he may have extended or adapted an existing building; or the assertion may be purely legendary). If, as the "), _c('em', [_vm._v("passio")]), _vm._v(" indicates, Peter was buried near this site, this would help to explain the importance of the church under Peter’s successors; its enlargement by Alexander may have been connected with an attempt to establish it as a pilgrimage centre, a shrine for the ‘crown’ of the Egyptian martyrs."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-116",
      "id": "ch1note_116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" Earlier bishops had been buried near the "), _c('em', [_vm._v("martyrium")]), _vm._v(" of Mark on the other side of the city."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-117",
      "id": "ch1note_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" If the identification of Boukolia with Baucalis "), _c('em', [_vm._v("is")]), _vm._v(" correct, Arius could have been custodian of the relics of Alexandria’s protomartyr and patron; a fact which would, no doubt, further have complicated his relations with the bishop and reinforced his prestige in the local church. But this is very uncertain: we have no firm information about the origins of the cult of St Mark in Alexandria, and the whole legend and cultus may date from after 300."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-118",
      "id": "ch1note_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" What is perhaps more likely is that the Boukolia church began as an oratory in or near what had become "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("a mainly Christian area of the eastern necropolis; there is no particular reason to doubt that a number of bishops were buried at this site, and the church would thus still have been a place of some significance.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("The other names in Epiphanius sound like house-churches. ‘Annianus’ is probably the same as the Annianus mentioned by Euse-bius"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-119",
      "id": "ch1note_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")]), _vm._v(" as Mark’s successor; if a house-church identified by this name was known to be the oldest continuously used oratory in the city, this might have been the source of a tradition that the first ‘sub-apostolic’ bishop was called Annianus. Of ‘Serapion’,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-120",
      "id": "ch1note_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" ‘Persaea’, and ‘Dizya’, we know nothing at all. ‘Pierius’ is an interesting case: almost certainly, it was the meeting-place of a congregation led by the Pierius who was head of the catechetical school in the late third century."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-121",
      "id": "ch1note_121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" There is reason to believe"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-122",
      "id": "ch1note_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" that he apostatized under persecution; yet he appears as a saint and martyr in later tradition."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-123",
      "id": "ch1note_123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" It has been plausibly suggested"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-124",
      "id": "ch1note_124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" that the existence of a church under his name fostered the mistaken belief that he was a martyr commemorated by the building.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The plurality of churches in Alexandria suggests that the beginnings of Christianity in the city were piecemeal and various – no single primitive congregation under its Catholic bishop. This picture is reinforced by such evidence as we have of the prevalence in and around the city of gnostic influences and the survival in ‘respectable’ circles of extracanonical literature."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-125",
      "id": "ch1note_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" The ‘catholicizing’ of the church was evidently well under way by the end of Demetrius’ episcopate (233),"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-126",
      "id": "ch1note_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" but the survival of numerous independent congregations evidently continued to pose problems. The assigning of regularly ordained presbyters to the local congregations probably goes back to the time of Demetrius,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-127",
      "id": "ch1note_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" and may have been an attempt to cement a rather fragile unity between the "), _c('em', [_vm._v("paroikiai.")]), _vm._v(" But the events of the early fourth century show the inadequacies and risks of this system. The presbyters – as has been noted – were not docile diocesan clergy but members of a collegiate body. It is not entirely surprising that we should come across disputes between bishop and presbyters over the respective limits of their authority.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Problems were no doubt intensified by the after-effects of persecution. We have seen that Bishop Peter’s flight from the city and the impotence or incompetence of his presbyteral commissaries created a vacuum which Melitius was only too eager to fill. In response to this unhappy legacy (and we should not forget the long "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("interregnum that followed Peter’s martyrdom), Alexander seems to have embarked on a campaign to consolidate the church around the bishop. Both Socrates"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-128",
      "id": "ch1note_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")]), _vm._v(" and the Emperor Constantine"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-129",
      "id": "ch1note_129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" represent Alexander as initiating discussion on a vexed theological and exegetical topic and attempting to give some sort of lead himself; indeed Constantine implies that Alexander demanded specimen exegeses from the presbyters, presumably to reassure himself that they were orthodox. The details and date are, as usual, obscure; what is clear is that Arius finally emerges into something like full historical light at this juncture. He and Alexander publicly repudiated each other’s theologies, and, although there is no suggestion that Arius wholly rejected the bishop’s authority, a tangible schism gradually developed: Alexander complains"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-130",
      "id": "ch1note_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" of separate conventicles of Arius’ supporters meeting for worship in the city – probably breakaway groups from churches whose presbyters continued to support the bishop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We do not know how many of these there were. Of those named by Epiphanius as ‘parish’ presbyters, two appear in the lists of Arius’ supporters;"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-131",
      "id": "ch1note_131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" and if the ‘Achillas’ who was initially closely associated with Arius"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-132",
      "id": "ch1note_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" is the head of the "), _c('em', [_vm._v("didaskaleion")]), _vm._v(" described in laudatory terms by Eusebius,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-133",
      "id": "ch1note_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" the pro-Arius faction in the presbyteral college was impressively weighty. However, Epiphanius plainly implies that there were sharp rivalries between the presbyters themselves, and that their followers already constituted distinct parties: if this is true, it would be wrong to see Arius as the figurehead of a "), _c('em', [_vm._v("general")]), _vm._v(" presbyteral revolt against Alexander’s ‘papalism’. And the subscriptions to Alexander’s culminating pronouncement against Arius"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-134",
      "id": "ch1note_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" testify that the overwhelming majority in the presbyterate – including, presumably, at least some of the parish priests, as well as the presbyters attached to the bishop’s offices or working outside the city boundaries – continued to support the bishop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The most conspicuous odd man out is the celebrated Colluthus. Alexander"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-135",
      "id": "ch1note_135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" states that Colluthus used the crisis provoked by Arius as an excuse for initiating or maintaining some kind of schismatic activity: the most satisfactory interpretation of this not very clear text is that Colluthus was already presiding over independent congregations in the city (and Epiphanius"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-136",
      "id": "ch1note_136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" claims that his supporters described themselves as ‘Colluthians’ at the period prior to the Arian crisis), but exploited the troubled situation brought about by Arius and Achillas to justify his continuing in schism. "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("From later testimony by Athanasius,"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-137",
      "id": "ch1note_137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")]), _vm._v(" we learn that Colluthus had at some point begun to ordain his own clergy – a painful reminder for any Alexandrian bishop of the persisting problem of Melitius. Colluthus obviously considered himself to be a bishop; Alexander’s remarks suggest that the presbyter was dissatisfied with Alexander’s leadership, and especially with his handling of Arius and Achillas. This implies that Colluthus represented an opposite theological extreme to Arianism (some kind of monarchianism?), for which Alexander’s views would be almost as suspect as Arius’. The bishop’s supposed unorthodoxy would disqualify him from his office, which would devolve upon a fitter candidate – probably the presbyter next in seniority."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-138",
      "id": "ch1note_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Arius and Achillas did not go this far (and, accordingly to Alexander, disapproved strongly of Colluthus’ handling of ecclesiastical funds);"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-139",
      "id": "ch1note_139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" but they had in Colluthus the precedent for resisting an episcopal authority believed to be heretical. As the last few pages have been designed to show, neither Colluthus nor Arius was doing anything that the history of the Alexandrian churches would not have led us to expect. The beginnings of Arianism lie, as much as anything, in the struggles of the Alexandrian episcopate to control and unify a spectacularly fissiparous Christian body – and thus also in a characteristic early Christian uncertainty about the ultimate locus of ecclesiastical authority itself (we shall be coming back to this issue in I.C. below). Alexander, as his letter to Alexander of Byzantium about the local troubles amply shows, felt himself threatened with the virtual disintegration of the Alexandrian church into a bundle of mutually hostile sects.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As we shall see,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-140",
      "id": "ch1note_140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" Colluthus’ eventual reconciliation and submission to Alexander was made possible through the decisive and final rejection of Arius and his party by the bishops and clergy of Egypt. Repeated and uncompromising episcopal denunciations of the Arian faction must have made Colluthus’ position less and less defensible; the fact that he was allowed to continue as a presbyter in good standing"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-141",
      "id": "ch1note_141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" does suggest, however, that he demanded a price for his return to Catholic obedience, a kind of canonical safe-conduct in return for his eagerness to join in the excommunication of Arius’ faction. The years between the outbreak of the controversy and the Council of Nicaea evidently saw a good deal of hard work in Alexandria, aimed at uniting the church against a single common enemy. The solid anti-Arianism of the majority of the Alexandrian "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("Christians for the rest of the century owes something to this period as well as to the efforts and the personality of Athanasius.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("At this point, it is necessary to turn to the very complex questions arising out of the uncertain chronology of events during these years. Our primary evidence consists in a number of relatively brief and and sometimes very fragmentary documents surviving for the most part in dossiers and chronicles of much later date. The standard collection of documentary sources made by Hans-Georg Opitz"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/027_Endnotes#ch1note-142",
      "id": "ch1note_142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")]), _vm._v(" remains indispensable; but it does not provide a fully consistent and satisfactory chronology for either the pre- or the post-Nicene period. Absolute precision is impossible, given that we have so few external fixed points against which to check conclusions, but the documents give us a reasonable amount of internal evidence; and their intrinsic interest amply justifies a close inspection of their contents.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45e03e78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/011_Chapter01.vue
// module id = 87
// module chunks = 0